<template>
  <div class="h-full">
    <images editable upload />
  </div>
</template>

<script>
const Images = require("@/modules/images/components/Images.vue").default;

export default {
  name: "ImagesSite",
  data() {
    return {};
  },
  props: {},
  components: {
    Images
  },
  methods: {},
  computed: {},
  created() {}
};
</script>